/** 引数で渡したオブジェクトが空オブジェクトの場合に`true`を返す関数 */
export const isEmptyObject = (obj: Record<string, unknown>) => {
  return Object.keys(obj).length === 0;
};
